/**
 * QuickView Context - Shared State Management
 * 
 * Provides a shared QuickView state across all components, ensuring
 * that product cards and the modal provider use the same state instance.
 */

import React, { createContext, useContext, ReactNode } from 'react';
import { useQuickView, QuickViewHookReturn } from '@/hooks/useQuickView';

interface QuickViewContextProps {
  children: ReactNode;
}

// Create the context with the same interface as useQuickView
const QuickViewContext = createContext<QuickViewHookReturn | undefined>(undefined);

export const QuickViewContextProvider = ({ children }: QuickViewContextProps) => {
  const quickViewState = useQuickView();
  
  return (
    <QuickViewContext.Provider value={quickViewState}>
      {children}
    </QuickViewContext.Provider>
  );
};

// Hook to use the shared QuickView context
export const useQuickViewContext = (): QuickViewHookReturn => {
  const context = useContext(QuickViewContext);
  if (!context) {
    throw new Error('useQuickViewContext must be used within a QuickViewContextProvider');
  }
  return context;
};